import React from "react";
import Question from "@assets/svg/WithdrawGullakMoney/Question";
import color from "@constants/color";
import t from "@constants/localization";

const { Text, StyleSheet, Pressable } = require("react-native");

const FindUpi = ({ navigation }) => {
  const PATH = "screens/WithDrawGullakMoney/findUpi";
  return (
    <Pressable
      testID="find-upi"
      style={styles.container}
      onPress={() => {
        navigation.navigate("FindUpi");
      }}
    >
      <Question />
      <Text style={styles.text}>{t(`${PATH}/howfindUPI`)}</Text>
    </Pressable>
  );
};

export default FindUpi;

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
  },
  text: {
    fontSize: 14,
    color: color.mediumBlack,
    fontWeight: "700",
    marginLeft: 4,
    textDecorationLine: "underline",
  },
});
